export default function (data) {
  return {
    module: 'SLogoRow',
    ...data
  };
}
